export default __webpack_public_path__ + "static/media/cont_logo.52f48d3c.png";